import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { systemIsPos } from "@biteinc/common";
//#region src/services/core_vendor_service.ts
var core_vendor_service_exports = /* @__PURE__ */ __exportAll({
	getFullPosI9nOfVendor: () => getFullPosI9nOfVendor,
	isVendorIntegrated: () => isVendorIntegrated
});
async function isVendorIntegrated(location, vendorId) {
	return !!await getFullPosI9nOfVendor(location, vendorId);
}
async function getFullPosI9nOfVendor(location, vendorId) {
	await location.attachIntegrations();
	return location.integrations.find((i9n) => {
		return systemIsPos(i9n.data.system) && i9n.data.vendorId.equals(vendorId);
	}) || null;
}
//#endregion
export { core_vendor_service_exports, getFullPosI9nOfVendor, isVendorIntegrated };

//# sourceMappingURL=core_vendor_service.js.map